import { Component, ElementRef, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { DomSanitizer } from '@angular/platform-browser';
import { SingService } from '../../service/sing.service';
import { responseSaveExpense } from 'app/components/class/http/res/response-save-expense';
import { responseGetExpense } from 'app/components/class/http/res/response-get-expense';
import { responseAddExpense } from 'app/components/class/http/res/response-add-expense';
import { UploadFiles } from 'app/components/interfaces/expense/upload-files';
import {ActionsService} from './services/actions.service';
import { Expense } from 'app/components/class/expense/expense';
import { ExpenseService } from 'app/components/rtb/info/services/info.component.service';
import { TableData } from 'app/components/class/table-data';
import { Settings } from 'app/components/class/setting';

@Component({
  selector: 'app-info-budget',
  templateUrl: './info-budget.component.html',
  styleUrls: ['./info-budget.component.css'],
  providers: [ActionsService]
})
export class InfoBudgetComponent implements OnInit {
  dropzone = null;
  init = false;
  newExpense = false;
  dealerShipId = "0";
  categoryId = 0;
  month;
  year;
  quarter;
  flightDates = [];
  files = [];
  category = ''
  product = ''
  campaign = '';
  budget = 0;
  coop = 0;
  description = '';
  strategy = '';
  notes = '';
  Actualbudget = 0;
  id = 0;
  creativeId;
  productId: 0;
  days = [];
  weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  currentMonth = "";
  calendarOpen = false;
  flightSelected = 0;
  calendarInput = '';
  selectingDate = false;
  selectedIndex = 0;
  selectedDays = {
    start: 0,
    end: 0
  }
  creatNew = false;
  change = false;
  campaignInputOpen = false;
  budgetInputOpen = false;
  actualInputOpen = false;
  coopInputOpen = false;
  descriptionInputOpen = false;
  StrategyInputOpen = false;
  notesInputOpen = false;
  width = '0';
  filesWidth = '100%';
  fileWidth = "100%";
  fotoramaInit: boolean = false;
  fotoramaData: any = null;
  uploadFileData: UploadFiles = { count: 0, length: 0, complete: false };
  indexFolder:number = 0;
  constructor(private broadcaster: Broadcaster, private ref: ChangeDetectorRef, private elRef: ElementRef, private sanitizer: DomSanitizer, private httpService: SingService,private InfoService: ActionsService) { }

  ngOnInit() {
    Dropzone.autoDiscover = false;
    this.broadcaster.on<any>("sendBudgetData").subscribe(data => {
      this.month = data.date.month;
      this.year = data.date.year;
      this.quarter = data.date.quarter;
      this.currentMonth = this.months[parseInt(data.date.month) - 1];
    })
    this.broadcaster.on<any>("sendNewBudgetData").subscribe(data => {
      this.month = data.date.month;
      this.year = data.date.year;
      this.quarter = data.date.quarter;
      this.currentMonth = this.months[parseInt(data.date.month) - 1];
    })

  }
  ngAfterViewInit() {
    this.broadcaster.on<any>("openInfoBudget").subscribe(data => {
      this.uploadFileData = { count: 0, length: 0, complete: false };
      const tableHeading = document.getElementById('fixedHeader');
      const header = document.querySelector('header');

      tableHeading.classList.add('hid');
      header.classList.remove('m--fixed')
     
    
      if (data.makeNew) {
        let end = new Date(this.year, this.month, 0).toString().split(" ");
        let month;
        if (this.month < 10) {
          month = `0${this.month}`
        } else {
          month = `${this.month}`
        }
        let flight = {
          class: 'flightSelected',
          targetBudget: 0,
          start: {
            month: month,
            day: '01',
            year: `${this.year}`
          },
          end: {
            month: month,
            day: `${end[2]}`,
            year: `${this.year}`
          },
          percent: 100
        }
        this.newExpense = true;
        this.dealerShipId = data.dealerShipId;
        this.categoryId = data.categoryId;
        this.files = [];
        this.flightDates = [flight];

        this.category = "";
        this.product = data.productTitle;
        this.budget = 0;
        this.Actualbudget = 0;
        this.coop = 0;
        this.description = "";
        this.strategy = "";
        this.notes = "";
        this.id = 0;
        this.productId = data.productId;
        this.creativeId = "";
        this.initCalendar(this.month, this.year);
        if (data.campaign) {
          this.campaign = data.campaign
        } else {
          this.campaign = ""
        }

        document.querySelector(".fileSlide").classList.add('hid');
        this.elRef.nativeElement.querySelector('.infoBudgetUploadBody').style.display = 'flex';
        this.elRef.nativeElement.querySelector('.googleImg').style.display = 'block';
        if (this.fotoramaData !== null) {

          $('.fileSlide').slick('unslick');
          this.fotoramaData = null;
          this.fotoramaInit = false;
        }

      } else {
        this.indexFolder = data.data.folders.findIndex(item => item.folderId === 0);
        let files = [];
        if (data.data.creativeId !== "") {
          let file = this.sanitizer.bypassSecurityTrustResourceUrl(`https://drive.google.com/file/d/${data.data.creativeId.id}/preview`);
          files.push(file)
        }
        if (data.data.folders[this.indexFolder].files.length > 0) {
          for (let f of data.data.folders[this.indexFolder].files) {
            let file = this.sanitizer.bypassSecurityTrustResourceUrl(f.url);
            files.push({ url: file, type: f.type,extension:f.extension });
          }
        }
        if (files.length > 0) {
          this.filesWidth = `${parseFloat(this.filesWidth) * files.length}%`;
          this.fileWidth = `${100 / files.length}%`;
          document.querySelector(".fileSlide").classList.remove('hid');
          this.elRef.nativeElement.querySelector('.infoBudgetUploadBody').style.display = 'none';
          this.elRef.nativeElement.querySelector('.googleImg').style.display = 'none';
        }
        else {
          document.querySelector(".fileSlide").classList.add('hid');
          this.elRef.nativeElement.querySelector('.infoBudgetUploadBody').style.display = 'flex';
          this.elRef.nativeElement.querySelector('.googleImg').style.display = 'block';
        }

        if (this.fotoramaData !== null) {

          $('.fileSlide').slick('unslick');
          this.fotoramaData = null;
          this.fotoramaInit = false;
        }
        this.files = files;
     
        this.initFlightDates(data.data.flightDate, data.data.targetBudget);
        this.flightDates[0].class = 'flightSelected';
        this.category = data.data.productCategoryName;
        this.product = data.data.productName;
        this.campaign = data.data.campaign;
        this.Actualbudget = data.data.actualBudget;
        this.budget = data.data.targetBudget;
        this.coop = data.data.coop;
        this.description = data.data.description;
        this.strategy = data.data.strategy;
        this.notes = data.data.notes;
        this.id = data.data.id;
        this.productId = data.data.productId;
        this.creativeId = data.data.creativeId;
      }
      this.initCalendar(this.month, this.year);
      document.querySelector(".infoBudget").classList.remove("infoClosed");

      document.querySelector(".tableWrapper").classList.add('infoOpen');
      document.querySelector("footer").classList.add('hid');
      document.querySelector('.closeHeader').classList.remove('hid');
    
      if (this.dropzone) {
        this.dropzone.options.url = `/api/files/upload?expenseId=${this.id}&folderId=0`;
      }
      $(".dropzoneInfo").attr("action", `/api/files/upload?expenseId=${this.id}&folderId=0`);
      if (this.init === false) {
        this.initDropzone();
      }

    });
    this.broadcaster.on<any>("confirmBudgetBroadcast").subscribe(data => {
      if (data.data === "Delete") {
        this.closeCalendar();
      }
    })
    window.addEventListener("click", (e) => {
      let elm = <HTMLElement>e.target;
      if (elm.classList.contains("cBudget")) {
        return
      }
      if (this.calendarOpen && this.change === true && !elm.classList.contains('calen') && !elm.classList.contains("nCalen")) {
        this.broadcaster.broadcast('confirmBudget', {
          data: "delete",
          text: "Are you sure? Everything not saved will be lost."
        });
      } else if ((this.calendarOpen && elm.classList.contains('nCalen')) || (this.calendarOpen && !elm.classList.contains('calen') && !this.change)) {
        this.closeCalendar();
      }
      if (this.campaignInputOpen === true && !elm.classList.contains('camp')) {
        this.hideCampaignInput();
      }
      if (this.budgetInputOpen === true && !elm.classList.contains('bud')) {
        this.hideBudgetInput();
      }
      if (this.actualInputOpen === true && !elm.classList.contains('actl')) {
        this.hideActualBudgetInput();
      }
      if (this.coopInputOpen === true && !elm.classList.contains('coop')) {
        this.hideCoopInput();
      }
      if (this.descriptionInputOpen === true && !elm.classList.contains('desc')) {
        this.hideDescriptionInput();
      }
      if (this.StrategyInputOpen === true && !elm.classList.contains('strat')) {
        this.hideStrategyInput();
      }
      if (this.notesInputOpen === true && !elm.classList.contains('notes')) {
        this.hideNotesInput();
      }
    })
  }
  initFlightDates(arr, targetBudget) {
    arr.map((flight) => {
      let f = {
        class: '',
        percent: parseFloat(((flight.targetBudget / targetBudget) * 100).toFixed(1)),
        start: {
          month: '',
          day: '',
          year: ''
        },
        end: {
          month: '',
          day: '',
          year: ''
        },
        targetBudget: flight.targetBudget
      };
      if (flight.start.month < 10) {
        f.start.month = `0${flight.start.month}`
      } else {
        f.start.month = `${flight.start.month}`
      }
      if (flight.start.day < 10) {
        f.start.day = `0${flight.start.day}`
      } else {
        f.start.day = `${flight.start.day}`
      }
      if (flight.end.month < 10) {
        f.end.month = `0${flight.end.month}`
      } else {
        f.end.month = `${flight.end.month}`
      }
      if (flight.end.day < 10) {
        f.end.day = `0${flight.end.day}`
      } else {
        f.end.day = `${flight.end.day}`
      }
      this.flightDates.push(f)
    })
  }
  closeCalendar() {
    this.change = false;
    document.querySelector('.calendaria').classList.add('hid');
    this.calendarOpen = false;
    this.selectingDate = false;
    if (this.creatNew === true) {
      this.flightDates.splice(this.flightDates.length - 1, 1);
      this.creatNew = false;
      this.flightSelected = 0;
    }
  }
  close() {
    this.change = false;
    this.newExpense = false;
    this.flightDates = [];
    this.flightSelected = 0;
    document.querySelector(".infoBudget").classList.add("infoClosed");
    document.querySelector(".tableWrapper").classList.remove('infoOpen');
    document.querySelector("footer").classList.remove('hid');
    document.querySelector('.closeHeader').classList.add('hid');
    document.querySelector('.calendaria').classList.add('hid');
    this.elRef.nativeElement.querySelector('.infoBudgetUploadNoHover').style.display = 'table';
    this.elRef.nativeElement.querySelector('.googleImg').style.display = 'block';
    this.calendarOpen = false;
    this.broadcaster.broadcast('infoClosed', { data: 'closed' });
    this.elRef.nativeElement.querySelector('.infoBudgetDetails').scrollTo(0, 0);

  }
  initCalendar(month, year) {
    this.days = [];
    let start = new Date(`${month}/01/${year}`).toString().split(" ");
    let end = new Date(year, month, 0).toString().split(" ");
    let startIndex = this.weekdays.indexOf(start[0]);
    let endIndex = this.weekdays.indexOf(end[0]);
    let total = startIndex + (7 - (endIndex + 1)) + parseInt(end[2]);
    for (let i = 1; i <= total; i++) {
      if (i < startIndex + 1 || i - startIndex > parseInt(end[2])) {
        this.days.push({
          isDay: false,
          date: "",
          class: "noHover",
          selected: false
        })
      } else {
        this.days.push({
          isDay: true,
          date: (i - startIndex).toString(),
          class: "normal",
          selected: false
        })
      }
    }
  }
  editFlight(e, index) {
    this.selectingDate = false;
    let flights = document.querySelectorAll(".flightDateItem");
    let elm = <HTMLElement>flights[index];
    let offset = elm.offsetTop;
    let parent = <HTMLElement>document.querySelector(".infoBudgetFlightDatesBody");
    let pointer = <HTMLElement>document.querySelector('.point');
    pointer.style.top = `${offset - parent.offsetTop + 10 - parent.scrollTop}px`;
    this.calendarInput = this.flightDates[index].targetBudget;
    let start = this.flightDates[index].start.day;
    let end = this.flightDates[index].end.day;
    this.selectedDays.start = start;
    this.selectedDays.end = end;
    let sIndex = this.days.findIndex((i) => {
      return parseInt(i.date) == parseInt(start)
    });
    let eIndex = this.days.findIndex((i) => {
      return parseInt(i.date) == parseInt(end)
    });
    if (index !== this.flightSelected) {
      this.flightDates[index].class = 'flightSelected';
      this.flightDates[this.flightSelected].class = '';
      this.flightSelected = index;
    }
    for (let i = 0; i < this.days.length; i++) {
      if (i === sIndex && this.days[i].isDay) {
        this.days[i].class = "selected";
      } else if (i > sIndex && i < eIndex && this.days[i].isDay) {
        this.days[i].class = 'between'
      } else if (i === eIndex && this.days[i].isDay) {
        this.days[i].class = "selected"
      } else if (this.days[i].isDay) {
        this.days[i].class = "normal"
      } else {
        this.days[i].class = "noHover"
      }
    }
    
    document.querySelector(".calendaria").classList.remove('hid');
    this.calendarOpen = true;
  }
  changeCalendarInput(e) {
    this.change = true;
    this.calendarInput = e.target.value;
  }
  dateSelector(e, index, isDay) {
    if (this.days[index].isDay && (this.selectingDate === false || (this.selectingDate === true && index < this.selectedIndex))) {
      this.selectedDays.start = this.days[index].date;
      this.change = true;
      for (var i = 0; i < this.days.length; i++) {
        if (this.days[i].isDay) {
          this.days[i].class = "normal"
        }
      }
      this.selectingDate = true;
      this.selectedIndex = index;
      this.days[index].class = "selected";
    } else if (this.days[index].isDay) {
      this.change = true;
      this.selectedDays.end = this.days[index].date;
      for (var i = 0; i < this.days.length; i++) {
        if (i === this.selectedIndex && this.days[i].isDay) {
          this.days[i].class = "selected"
        } else if (i === index && this.days[i].isDay) {
          this.days[i].class = "selected"
        } else if (i > this.selectedIndex && i < index && this.days[i].isDay) {
          this.days[i].class = "between"
        } else if (this.days[i].isDay) {
          this.days[i].class = "normal"
        }
      }
      this.selectingDate = false;
    }
  }
  hoverSelector(e, index, isDay) {
    if (this.selectingDate === true) {
      for (var i = 0; i < this.days.length; i++) {
        if (i > this.selectedIndex && i <= index && this.days[i].isDay) {
          this.days[i].class = 'between'
        } else if (i !== this.selectedIndex && this.days[i].isDay) {
          this.days[i].class = 'normal'
        }
      }
    }
  }
  deleteFlight(i) {

    this.flightDates.splice(i, 1);
    this.flightSelected = 0;
    this.change = false;
    let num = 0;
    this.flightDates.map((f) => {
      num += parseFloat(f.targetBudget);
    })
    this.budget = parseFloat(num.toString());
    for (let i of this.flightDates) {
      i.percent = (this.budget === 0) ? 0 : Math.round((i.targetBudget / this.budget) * 1000) / 10;
    }
  }
  createNewFlight() {
    if (this.creatNew) {
      return
    }
    this.change = true;
    this.creatNew = true;
    for (let i of this.flightDates) {
      i.class = "normal";
    }
    for (let i of this.days) {
      if (i.isDay) {
        i.class = 'normal'
      }
    }
    let start = new Date(`${this.month}/01/${this.year}`).toString().split(" ");
    let end = new Date(this.year, this.month, 0).toString().split(" ");
    let month;
    this.selectedDays.start = 1;
    this.selectedDays.end = parseInt(end[2]);
    if (this.month < 10) {
      month = `0${this.month}`
    } else {
      month = `${this.month}`
    }
    let objDiv = document.querySelector(".infoBudgetFlightDatesBody");
    let flight = {
      class: 'flightSelected',
      targetBudget: 0,
      start: {
        month: month,
        day: '01',
        year: `${this.year}`
      },
      end: {
        month: month,
        day: `${end[2]}`,
        year: `${this.year}`
      },
      percent: 0
    }
    for (let i of this.days) {
      if (i.isDay && (i.date == 1 || i.date == end[2])) {
        i.class = "selected"
      } else if (i.isDay) {
        i.class = "between"
      }
    }
    this.flightDates.push(flight);
    this.flightSelected = this.flightDates.length - 1;
    this.calendarInput = '';
    document.querySelector(".calendaria").classList.remove('hid');
    this.calendarOpen = true;
    setTimeout(() => {
      let flights = document.querySelectorAll(".flightDateItem");
      let elm = <HTMLElement>flights[flights.length - 1];
      let offset = elm.offsetTop;
      let parent = <HTMLElement>document.querySelector(".infoBudgetFlightDatesBody");
      let pointer = <HTMLElement>document.querySelector('.point');
      if (flights.length >= 5) {
        pointer.style.top = `178px`;
      } else {
        pointer.style.top = `${offset - parent.offsetTop + 10}px`;
      }
      objDiv.scrollTop = objDiv.scrollHeight;
    }, 1)
  }
  resetCalendar() {
    this.change = false;
    this.editFlight('e', this.flightSelected);
  }
  submitCalendar() {
    let flight = this.flightDates[this.flightSelected];
    flight.start.day = this.selectedDays.start;
    flight.end.day = this.selectedDays.end;
    if (this.calendarInput === '') {
      this.calendarInput = "0"
    }
    flight.targetBudget = this.calendarInput;
    let num = 0;
    this.flightDates.map((f) => {
      num += parseFloat(f.targetBudget);
    })
    this.budget = parseFloat(num.toString());
    flight.percent = parseFloat(((parseFloat(this.calendarInput) / this.budget) * 100).toFixed(1))
    for (let i of this.flightDates) {
      i.percent = parseFloat(((parseFloat(i.targetBudget) / this.budget) * 100).toFixed(1))
    }
    this.creatNew = false;
    this.change = false;
  }
  movePointer() {
    let flights = document.querySelectorAll(".flightDateItem");
    let elm = <HTMLElement>flights[this.flightSelected];
    let offset = elm.offsetTop;
    let parent = <HTMLElement>document.querySelector(".infoBudgetFlightDatesBody");
    let pointer = <HTMLElement>document.querySelector('.point');
    pointer.style.top = `${offset - parent.offsetTop + 10 - parent.scrollTop}px`;
  }

  showCampaignInput() {
    document.getElementById('campaignInput').style.display = "block";
    document.getElementById('campaignInput').focus();
    document.getElementById('campaignText').style.display = "none";
    this.campaignInputOpen = true;

  }
  hideCampaignInput() {
    document.getElementById('campaignInput').style.display = "none";
    document.getElementById('campaignText').style.display = "block";
    this.campaignInputOpen = false;

  }
  changeCampaignInput(e) {
    this.campaign = e.target.value;
  }

  showBudgetInput() {
    document.getElementById('budgetInput').style.display = "block";
    let input: HTMLInputElement = (<HTMLInputElement>document.getElementById('budgetInput'));
    if (input.value === '0') {
      input.value = '';
    }
    input.focus();
   
    document.getElementById('budgetInput').focus();
    document.getElementById('budgetText').style.display = "none";
    this.budgetInputOpen = true;

  }
  showActualBudgetInput() {
    document.getElementById('ActualbudgetInput').style.display = "block";
    let input: HTMLInputElement = (<HTMLInputElement>document.getElementById('ActualbudgetInput'));
    if (input.value === '0') {
      input.value = '';
    }
    input.focus();
  
    document.getElementById('ActualbudgetText').style.display = "none";
    this.actualInputOpen = true;

  }
  hideActualBudgetInput() {
    document.getElementById('ActualbudgetInput').style.display = "none";
    document.getElementById('ActualbudgetText').style.display = "block";
    this.actualInputOpen = false;

  }
  hideBudgetInput() {
    document.getElementById('budgetInput').style.display = "none";
    document.getElementById('budgetText').style.display = "block";
    this.budgetInputOpen = false;

  }
  changeBudgetInput(e) {
    this.budget = parseFloat(e.target.value);
   
    for (let i of this.flightDates) {
      let percent = i.percent / 100;
      let num = this.budget * percent;
      if (num % 1 !== 0) {
        num = parseFloat(num.toFixed(2));
      }
    
      i.targetBudget = Math.round(((this.budget * i.percent) / 100) * 100) / 100;
      if (this.flightDates.length === 1) i.targetBudget = this.budget;
    }
    console.log('this.flightDates',this.flightDates);
    this.ref.detectChanges();
  }
  changeActualBudgetInput(e) {
    if (!e.target.value) {
      this.Actualbudget = 0;
    }
    else {
      this.Actualbudget = parseFloat(e.target.value);
    }


  }

  showCoopInput() {
    document.getElementById('coopInput').style.display = "block";
    let input: HTMLInputElement = (<HTMLInputElement>document.getElementById('coopInput'));
    if (input.value === '0') {
      input.value = '';
    }
    input.focus();
   
    document.getElementById('coopInput').focus();
    document.getElementById('coopText').style.display = "none";
    this.coopInputOpen = true;

  }
  hideCoopInput() {
    document.getElementById('coopInput').style.display = "none";
    document.getElementById('coopText').style.display = "block";
    this.coopInputOpen = false;

  }
  changeCoopInput(e) {
    if (!e.target.value) {
      this.coop = 0;
    }
    else {
      this.coop = parseFloat(e.target.value);
    }

  }

  showDescriptionInput() {
    document.getElementById('description').classList.add('selectedDownItem');
    document.getElementById('description').classList.remove('noText');
    document.getElementById('descriptionInput').classList.remove('hid');
    document.getElementById('descriptionInput').focus();
    this.descriptionInputOpen = true;

  }
  hideDescriptionInput() {
    this.descriptionInputOpen = false;
    if (this.description == '') {
      document.getElementById('description').classList.add('noText');
      document.getElementById('descriptionInput').classList.add('hid');
    }
    document.getElementById('description').classList.remove('selectedDownItem');

  }
  changeDescriptionInput(e) {
    this.description = e.target.value;
  }

  showStrategyInput() {
    document.getElementById('strategy').classList.add('selectedDownItem');
    document.getElementById('strategy').classList.remove('noText');
    document.getElementById('strategyInput').classList.remove('hid');
    document.getElementById('strategyInput').focus();
    this.StrategyInputOpen = true;

  }
  hideStrategyInput() {
    document.getElementById('strategy').classList.remove('selectedDownItem');
    this.StrategyInputOpen = false;
    if (this.strategy == '') {
      document.getElementById('strategy').classList.add('noText');
      document.getElementById('strategyInput').classList.add('hid');
    }
    document.getElementById('strategy').classList.remove('selectedDownItem');

  }
  changeStrategyInput(e) {
    this.strategy = e.target.value;
  }

  showNotesInput() {
    document.getElementById('notes').classList.add('selectedDownItem');
    document.getElementById('notes').classList.remove('noText');
    document.getElementById('notesInput').classList.remove('hid');
    document.getElementById('notesInput').focus();
    this.notesInputOpen = true;

  }
  hideNotesInput() {
    document.getElementById('notes').classList.remove('selectedDownItem');
    this.notesInputOpen = false;
    if (this.notes == '') {
      document.getElementById('notes').classList.add('noText');
      document.getElementById('notesInput').classList.add('hid');
    }
    document.getElementById('notes').classList.remove('selectedDownItem');

  }
  changeNotesInput(e) {
    this.notes = e.target.value;
  }

  save() {
    let flights = [];
    for (let i of this.flightDates) {
      let flight = {
        targetBudget: parseFloat(i.targetBudget),
        end: `${this.year}-${this.month}-${i.end.day}`,
        start: `${this.year}-${this.month}-${i.start.day}`
      }
      flights.push(flight)
    }
    if (this.newExpense === false) {
      let data:Expense = new Expense();
      data.onInitSave(
       {
        id: this.id,
        actualBudget: this.Actualbudget,
        targetBudget: this.budget,
        flightDate: flights,
        campaign: this.campaign,
        strategy: this.strategy,
        description: this.description,
        notes: this.notes,
        coop: this.coop,
        creativeId: this.creativeId
      },flights);
      this.InfoService.saveExpense(data).subscribe((data:responseSaveExpense) => {
        this.close();
        this.broadcaster.broadcast("updateBudget", null)
      })
    } else {
      let settings: Settings = JSON.parse(window.localStorage.getItem('settings'));
      let tableData:TableData = new TableData();
      tableData.setData(settings);
      tableData.settings.dealerShipId = Number(this.dealerShipId);
      let data:Expense = new Expense(); 
      data.onInitAdd(
        {
          productId: String(this.productId),
        productCategoryId: String(this.categoryId),
        targetBudget: this.budget,
        actualBudget: this.Actualbudget,
        flightDate: flights,
        campaign: this.campaign,
        strategy: this.strategy,
        description: this.description,
        notes: this.notes,
        coop: this.coop,
        creativeId: ""
      }, tableData);
      this.InfoService.addExpense(data).subscribe((data:responseAddExpense) => {
        this.close();
        this.broadcaster.broadcast("updateBudget", null)
      })
    }
  }
  callOnLastIteration() {
    if (this.fotoramaInit) return;
   
    this.fotoramaInit = true;
    if (this.fotoramaData) {
      $('.fileSlide').slick('unslick');
      this.fotoramaData = $('.fileSlide').slick({
        dots: false,
        arrows: true
      });
    }
    else {
      this.fotoramaData = $('.fileSlide').slick({
        dots: false,
        arrows: true
      });
    }

    let list = $(".files");
   
    for (let i = 0; i < list.length; i++) {
      //  list[i].setAttribute("src", list[i].getAttribute("data-url"));
    }
    this.ref.detectChanges();
  }

  changeProgress(size, progress) {
    let sizeText = document.getElementById('uploadSize');
    let uploadDiv = document.getElementById('dropzone');
    let progressBar = document.getElementById('progressFill');
    uploadDiv.classList.add('shorter');
    progressBar.style.width = `${progress}px`;
    sizeText.innerHTML = size;
  }
  initDropzone() {
    this.init = true;
    let stage = this;

   
    this.dropzone = new Dropzone(".dropzone", {
      /*  url: `/api/expense/file-upload?id=${this.id}`,*/
      previewTemplate: '',

      drop: function () {
      

      },
      accept: function (file, done) {
        done();
      },
      error: function (errorMessage) {
    
        let Errors = JSON.parse(errorMessage.xhr.response);
      },
      dragover: function () {

        stage.elRef.nativeElement.querySelector('.infoBudgetUploadNoHover').style.display = 'none';
        stage.elRef.nativeElement.querySelector('.infoBudgetUploadHover').style.display = 'table';
      },
      dragleave: function () {

        stage.elRef.nativeElement.querySelector('.infoBudgetUploadNoHover').style.display = 'table';
        stage.elRef.nativeElement.querySelector('.infoBudgetUploadHover').style.display = 'none';
      },
      addedfile: function (file) {
        stage.elRef.nativeElement.querySelector('.googleImg').style.display = 'none';
        stage.uploadFileData.length++;
      },
      thumbnail: function (file, dataUrl) {
      
      },
      uploadprogress: function (file, progress, bytesSent) {
        stage.elRef.nativeElement.querySelector('.progressUpload').classList.remove('hid');
        stage.elRef.nativeElement.querySelector('.progressUpload p').innerText = file.name;
        stage.elRef.nativeElement.querySelector('.progressUpload .progressSize').innerText = `${(file.size / 1000000).toFixed(1)} MB`;
        stage.elRef.nativeElement.querySelector('.uploaded').style.left = `${125 - progress * 1.25}px`;
      },
      sending: function (file, xhr, formData) {

        formData.append("uploadedFile", file);
        stage.elRef.nativeElement.querySelector('.infoBudgetUploadNoHover').style.display = 'none';
        stage.elRef.nativeElement.querySelector('.infoBudgetUploadHover').style.display = 'none';
      },
      complete: function () {
        stage.uploadFileData.count++;
        if (stage.uploadFileData.count === stage.uploadFileData.length) {
            stage.uploadFileData.complete = true;
        }
      }
    });
  }
  saveUpload() {
   
    this.httpService.getExpense(this.id).subscribe((data:responseGetExpense) => {
     
      for (let f of data.expense.folders[this.indexFolder].files) {
        let file = this.sanitizer.bypassSecurityTrustResourceUrl(f.url);
        this.files.push({ url: file, type: f.type,extension:f.extension });
      }
      if (this.files.length > 1) {

        if (this.fotoramaData !== null) {

          $('.fileSlide').slick('unslick');
          this.fotoramaData = null;
          this.fotoramaInit = false;
        }
      }
     

      this.elRef.nativeElement.querySelector('.progressUpload').classList.add('hid');
      this.elRef.nativeElement.querySelector(".fileSlide").classList.remove('hid');
      this.uploadFileData = { count: 0, length: 0, complete: false };
    })
  }
}




// WEBPACK FOOTER //
// ./src/app/components/budget/info-budget/info-budget.component.ts